import { sendWup, readBinBuffer, getUserId } from './taf.js'
import { HUYA, MidExtComm, MidExtOpenCoinBill } from './jce/MidExtOpenCoinBillServer';

async function coverSendWup(params) {
  const resp = await sendWup(params)
  const { bcode, response } = resp || {}
  if (bcode) {
    console.warn('请求失败', resp)
    const { msg } = response || {}
    throw new Error(`${msg || '请求失败'}: ${bcode}`)
  }
  return resp
}

export async function confirmProtocol() {
  const req = new MidExtOpenCoinBill.ConfirmOpenCoinCommissionProtocolReq()
  Object.assign(req.tId, getUserId())

  return await coverSendWup({
    servantName: 'midExtPayUI',
    funcName: 'extConfirmOpenCoinCommissionProtocol',
    req,
    rspClass: MidExtOpenCoinBill.ConfirmOpenCoinCommissionProtocolResp,
    readConfig: {},
  })
}

export async function getProtocol() {
  const req = new MidExtOpenCoinBill.GetConfirmedStatusReq()
  Object.assign(req.tId, getUserId())

  return await coverSendWup({
    servantName: 'midExtPayUI',
    funcName: 'extGetOpenCoinProtocolConfirmedStatus',
    req,
    rspClass: MidExtOpenCoinBill.GetConfirmedStatusResp,
    readConfig: {},
  })
}
